import React from 'react';
import ButtonDesigned from '../../../../../../components/UI-Elements/Buttons/ButtonDesigned';

export const CoQuoteDueDateButtonSection: React.FC<buttonProps> = ({
  disableButton,
  nextPageFunction,
  backPageFunction,
  refineFunction,
}) => {
  return (
    <div className="flex justify-end space-x-[1rem] ">
      <ButtonDesigned
        className="end"
        style="outline"
        onButtonClick={() => {
          backPageFunction();
        }}
        backButton={true}
      ></ButtonDesigned>
      <ButtonDesigned
        className="end"
        style="outline"
        onButtonClick={() => {
          refineFunction();
        }}
      >
        Refine
      </ButtonDesigned>
      <ButtonDesigned
        className="end"
        style="outline"
        onButtonClick={() => {
          nextPageFunction();
        }}
        disableButton={disableButton}
        nextButton={true}
      ></ButtonDesigned>
    </div>
  );
};
interface buttonProps {
  backPageFunction: () => void;
  refineFunction: () => void;
  nextPageFunction: () => void;
  disableButton: boolean;
}
